import { components, schemas } from '@convergence/client';
import { useMutation } from '@tanstack/react-query';
import { fetch } from '../fetch';

type Body = components['schemas']['UpdateUserBody'];

export function updateUser(body: Body) {
  return fetch(
    '/user',
    { method: 'PATCH', body: JSON.stringify(body) },
    schemas.SuccessDto
  );
}

export function useUpdateUserMutation() {
  const m = useMutation({
    mutationKey: ['updateUser'],
    mutationFn: (body: Body) => updateUser(body)
  });

  return { ...m, updateUser: m.mutateAsync };
}
